module.exports = __webpack_public_path__ + "static/media/default.43bf9173.jpg";